import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiUrl , APIRequest } from "../utils/api";

export const fetchVendorStores = createAsyncThunk(
  "vendorStore/fetchVendorStores",
  async (_, { rejectWithValue }) => {
    try {
      const config = {
        url: ApiUrl.getVendorStore,
        method: "get",
      };

      return new Promise((resolve, reject) => {
        APIRequest(
          config,
          (response) => {
            if (!response?.error && response?.data) {
              resolve(response.data);
            } else {
              reject("Failed to fetch stores");
            }
          },
          (error) => reject(error)
        );
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  {
    condition: (_, { getState }) => {
      const { vendorStore } = getState();

      // If stores already exist, skip API call
      if (vendorStore.stores.length > 0) {
        return false;
      }
    },
  }
);

export const fetchVendorStoreLocations = createAsyncThunk(
  "vendorStore/fetchVendorStoresLocations",
  async (_, { rejectWithValue }) => {
    try {
      const config = {
        url: ApiUrl.getStoreLocationDetails,
        method: "post",
      };

      return new Promise((resolve, reject) => {
        APIRequest(
          config,
          (response) => {
            if (!response?.error && response?.data) {
              resolve(response.data);
            } else {
              reject("Failed to fetch store locations");
            }
          },
          (error) => reject(error)
        );
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  {
    condition: (_, { getState }) => {
      const { vendorStore } = getState();

      const CACHE_TIME =  60 * 1000; // 5 minutes

      if (
        vendorStore.locations?.length > 0 &&
        vendorStore.lastFetchedAt &&
        Date.now() - vendorStore.lastFetchedAt < CACHE_TIME
      ) {
        return false;
      }

      return true;
    },
  }
);

const vendorStoreSlice = createSlice({
  name: "vendorStore",
  initialState: {
    stores: [],
    locations: [],
    lastFetchedAt: null,
    selectedStore: null,
    loading: false,
  },
  reducers: {
    setSelectedStore: (state, action) => {
      state.selectedStore = action.payload;
    },
    invalidateLocations: (state) => {
      state.lastFetchedAt = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorStores.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVendorStores.fulfilled, (state, action) => {
        state.loading = false;
        state.stores = action.payload;
      })
      .addCase(fetchVendorStores.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchVendorStoreLocations.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVendorStoreLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
        state.lastFetchedAt = Date.now();
      })
      .addCase(fetchVendorStoreLocations.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setSelectedStore } = vendorStoreSlice.actions;
export default vendorStoreSlice.reducer;